//
//
//
//
//
//
//
//
//
//
//

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.component('HStack', component.exports)
}
export default {
	// functional: true,
	props: {
		gap: {
			type: [String, Array],
			default: '0'
		},
		padX: {
			type: [String, Array],
			default: '0'
		},
		padY: {
			type: [String, Array],
			default: '0'
		},
		as: {
			type: String,
			default: 'div'
		}
	}
	// render: function(createElement) {
	// 	return createElement(
	// 		this.as, // tag name
	// 		{
	// 			class: 'h-stack',
	// 			style: `--h-stack-gap: var(--s${this.gap}); --h-stack-padY: var(--s${this.padY});  --h-stack-padX: var(--s${this.padX});`
	// 		},
	// 		this.$slots.default // array of children
	// 	);
	// }
};
